import React, {Component} from 'react';
import ErrorBoundary from '../../components/ErrorBoundary';
import CardSection from '../../components/CardSection/CardSection.js';
import Header from '../header/Header.js';
import './App.css';
import config from './config.json';
// import config from './config-sample.json';


class App extends Component {
  constructor (props) {
    super(props);
    this.handleNewDay = this.handleNewDay.bind(this);

    const params = new URLSearchParams(this.props.location.search); 
    const day = params.get('day');
    this.state = {day: this.makeMyDay(day)};
    // console.log('props', this.props);
  }


  makeMyDay (day='') {
    // TBD: validate day is valid for Date parameter
    // , check Date return value
    let d = (day && day !=='') ? new Date(day) : new Date();    
    return ''+(d.getMonth()+1)+'/'+d.getDate()
  }
      
  handleNewDay (new_day) {
    this.setState({day: new_day})  
    this.props.history.push(`${window.location.pathname}?day=+${new_day}`)
  }


  render () {
    return (
      <div className="App">
        <Header day={this.state.day} handleNewDay={this.handleNewDay}/>
        <ErrorBoundary>
          <CardSection day={this.state.day} section={config.categories[0]}  />
          <CardSection day={this.state.day} section={config.categories[1]} />
        </ErrorBoundary>
        {/* <WigglebackFooter/> */}
     </div>   
    )
  }

}

export default App;
